// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.RoiRegion in roi/roiConfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Roi single region describing 4-point polygonal ROI
 *
 * @property points ROI coordinates:
 *  - Index 0: (x1, y1) -> Top Left
 *  - Index 1: (x2, y2) -> Top Right
 *  - Index 2: (x3, y3) -> Bottom Right
 *  - Index 3: (x4, y4) -> Bottom Left
 */
public class RoiRegion(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val x1: Int = 0,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val y1: Int = 0,
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 2,
  )
  public val x2: Int = 0,
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 3,
  )
  public val y2: Int = 0,
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 4,
  )
  public val x3: Int = 0,
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 5,
  )
  public val y3: Int = 0,
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 6,
  )
  public val x4: Int = 0,
  @field:WireField(
    tag = 8,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 7,
  )
  public val y4: Int = 0,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<RoiRegion, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is RoiRegion) return false
    if (unknownFields != other.unknownFields) return false
    if (x1 != other.x1) return false
    if (y1 != other.y1) return false
    if (x2 != other.x2) return false
    if (y2 != other.y2) return false
    if (x3 != other.x3) return false
    if (y3 != other.y3) return false
    if (x4 != other.x4) return false
    if (y4 != other.y4) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + x1.hashCode()
      result = result * 37 + y1.hashCode()
      result = result * 37 + x2.hashCode()
      result = result * 37 + y2.hashCode()
      result = result * 37 + x3.hashCode()
      result = result * 37 + y3.hashCode()
      result = result * 37 + x4.hashCode()
      result = result * 37 + y4.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """x1=$x1"""
    result += """y1=$y1"""
    result += """x2=$x2"""
    result += """y2=$y2"""
    result += """x3=$x3"""
    result += """y3=$y3"""
    result += """x4=$x4"""
    result += """y4=$y4"""
    return result.joinToString(prefix = "RoiRegion{", separator = ", ", postfix = "}")
  }

  public fun copy(
    x1: Int = this.x1,
    y1: Int = this.y1,
    x2: Int = this.x2,
    y2: Int = this.y2,
    x3: Int = this.x3,
    y3: Int = this.y3,
    x4: Int = this.x4,
    y4: Int = this.y4,
    unknownFields: ByteString = this.unknownFields,
  ): RoiRegion = RoiRegion(x1, y1, x2, y2, x3, y3, x4, y4, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<RoiRegion> = object : ProtoAdapter<RoiRegion>(
      FieldEncoding.LENGTH_DELIMITED, 
      RoiRegion::class, 
      "type.googleapis.com/vreo.volt.protocol.RoiRegion", 
      PROTO_3, 
      null, 
      "roi/roiConfig.proto"
    ) {
      override fun encodedSize(`value`: RoiRegion): Int {
        var size = value.unknownFields.size
        if (value.x1 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.x1)
        }
        if (value.y1 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(2, value.y1)
        }
        if (value.x2 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(3, value.x2)
        }
        if (value.y2 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(4, value.y2)
        }
        if (value.x3 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(5, value.x3)
        }
        if (value.y3 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(6, value.y3)
        }
        if (value.x4 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(7, value.x4)
        }
        if (value.y4 != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(8, value.y4)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: RoiRegion) {
        if (value.x1 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.x1)
        }
        if (value.y1 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 2, value.y1)
        }
        if (value.x2 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 3, value.x2)
        }
        if (value.y2 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.y2)
        }
        if (value.x3 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 5, value.x3)
        }
        if (value.y3 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 6, value.y3)
        }
        if (value.x4 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 7, value.x4)
        }
        if (value.y4 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 8, value.y4)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: RoiRegion) {
        writer.writeBytes(value.unknownFields)
        if (value.y4 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 8, value.y4)
        }
        if (value.x4 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 7, value.x4)
        }
        if (value.y3 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 6, value.y3)
        }
        if (value.x3 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 5, value.x3)
        }
        if (value.y2 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.y2)
        }
        if (value.x2 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 3, value.x2)
        }
        if (value.y1 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 2, value.y1)
        }
        if (value.x1 != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.x1)
        }
      }

      override fun decode(reader: ProtoReader): RoiRegion {
        var x1: Int = 0
        var y1: Int = 0
        var x2: Int = 0
        var y2: Int = 0
        var x3: Int = 0
        var y3: Int = 0
        var x4: Int = 0
        var y4: Int = 0
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> x1 = ProtoAdapter.INT32.decode(reader)
            2 -> y1 = ProtoAdapter.INT32.decode(reader)
            3 -> x2 = ProtoAdapter.INT32.decode(reader)
            4 -> y2 = ProtoAdapter.INT32.decode(reader)
            5 -> x3 = ProtoAdapter.INT32.decode(reader)
            6 -> y3 = ProtoAdapter.INT32.decode(reader)
            7 -> x4 = ProtoAdapter.INT32.decode(reader)
            8 -> y4 = ProtoAdapter.INT32.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return RoiRegion(
          x1 = x1,
          y1 = y1,
          x2 = x2,
          y2 = y2,
          x3 = x3,
          y3 = y3,
          x4 = x4,
          y4 = y4,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: RoiRegion): RoiRegion = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
